/**
 * The embed page's own address, as the player writes it.
 *
 * The page reads its options from its query itself and hands them to the player as its config —
 * `start_at` and `start_index` among them (`crates/bin/api/src/embed/config.rs`; a channel's framed
 * item reads `start_at`, `crates/bin/sites/src/external.rs`). The parameters are the registry's
 * (`EMBED_OPTION_META`), so a link writes what the page reads.
 */

import { EMBED_OPTION_META } from '../../apps/assets/utils/embedSrc'

/** Whether `url` is an embed page, `/embed/{uid}` — the page whose address seeks. */
export function isEmbedPage(url: URL): boolean {
  return /^\/embed\//.test(url.pathname)
}

/**
 * The embed page's address at `seconds` into the entry at `index`: `start_at` in whole seconds,
 * `start_index` past the first entry, and every other parameter of the page as it was.
 */
export function linkToInstant(page: URL, seconds: number, index: number): string {
  const url = new URL(page)
  url.searchParams.set(EMBED_OPTION_META.startAt.param, String(Math.floor(seconds)))
  if (index > 0) url.searchParams.set(EMBED_OPTION_META.startIndex.param, String(index))
  else url.searchParams.delete(EMBED_OPTION_META.startIndex.param)
  return url.toString()
}
